module.exports = __webpack_public_path__ + "static/img/9.358546c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/9.png
// module id = VNz7
// module chunks = 0